/** Illustrations for the primer slides.
 *
 * Slide A uses the canonical RISE app screenshot (compressed PNG —
 * tracker view with Sleep Debt dial, Energy potential, and the
 * Zepbound medication-tracker card). Slide C uses an inline SVG grid.
 */

import styles from './PrimerIllustrations.module.css';
import slideATracker from 'surveys/osa_funnel/assets/primer/slide-a-tracker.png';
import slideCDaily from 'surveys/osa_funnel/assets/primer/slide-c-daily-utility.png';

/** Slide A — the canonical RISE app tracker screenshot.
 *
 *  Shows: −3 hrs context chip → 17 hrs Sleep Debt dial → 8h 30m / Nap
 *  chips → 35% Energy potential → Grogginess / Morning peak insights
 *  → Zepbound medication tracker card with next-dose row. Compressed
 *  PNG (20 KB) sourced from the design team. */
export const SlideAIllustration = () => (
  <div className={styles.trackerImageWrap}>
    <img src={slideATracker} alt="" aria-hidden="true" className={styles.trackerImage} draggable={false} />
  </div>
);

/** Slide C — daily-utility composite.
 *
 *  Canonical product mockup: watch face + RISE app icon + calendar
 *  widget + "Finally time to unwind" notification + Morning peak
 *  insight + Zepbound pill icon. Compressed PNG (17 KB). */
export const SlideCIllustration = () => (
  <div className={styles.dailyImageWrap}>
    <img src={slideCDaily} alt="" aria-hidden="true" className={styles.dailyImage} draggable={false} />
  </div>
);
